import Swiper from "swiper";
import { SwiperOptions } from "swiper/types/swiper-options";
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

const fadeIn = () => {
    const lists = document.querySelectorAll(
        ".jobs-carousel .attrax-list-widget__list, .post-carousel .attrax-list-widget__list"
    );
    lists.forEach((list) => list.classList.add("show"));
};

const createNavigationButtonContainer = (swiperInstance: Swiper) => {
    const wrapper = document.createElement("div");
    wrapper.classList.add("swiper-nav-btn-container");
    const navButtons = swiperInstance.el.querySelectorAll(
        ".swiper-button-prev, .swiper-button-next"
    );

    for (let btn of navButtons) {
        btn.remove();
        wrapper.appendChild(btn);
    }

    swiperInstance.el.appendChild(wrapper);
};

const createViewAllButtonContainer = (swiperInstance: Swiper) => {
    const wrapper = document.createElement("div");
    wrapper.classList.add("swiper-view-all");
    const viewAllButton = swiperInstance.el.querySelectorAll(
        ".swiper-slide.attrax-button"
    );

    for (let btn of viewAllButton) {
        btn.remove();
        btn.classList.remove("swiper-slide");
        btn.setAttribute("style", "");
        btn.setAttribute("aria-label", "view all");
        wrapper.appendChild(btn);
    }

    swiperInstance.el.appendChild(wrapper);
};

const createCarousel = (el: string, opt: SwiperOptions) => {
    const elements = document.querySelectorAll(el);

    elements.forEach((element: HTMLElement) => {
        const children = [...element.children];

        element.classList.add("swiper");
        for (let child of children) {
            child.classList.add("swiper-slide");
        }

        const pagination = document.createElement("div");
        pagination.classList.add("swiper-pagination");
        element.appendChild(pagination);

        const swiper = new Swiper(element, {
            modules: [ Navigation, Pagination ],
            createElements: true,
            navigation: true,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            on: {
                afterInit: (swiper) => {
                    createNavigationButtonContainer(swiper);
                },
            },
            ...opt,
        });
    });
};

const createListWidgetCarousel = () => {
    const swiper = createCarousel(".jobs-carousel .attrax-list-widget__list--has-items", {
        modules: [ Navigation, Pagination ],
        slidesPerView: 1.1,
        navigation: true,
        spaceBetween: 10,
        breakpoints: {
            0: {
                slidesPerView: 1.1,
            },
            630: {
                slidesPerView: 2,
            },
            990: {
                slidesPerView: 3,
                spaceBetween: 20,
            },
        },
        on: {
            afterInit: (swiper) => {
                createNavigationButtonContainer(swiper);
                createViewAllButtonContainer(swiper);
                fadeIn();
            },
        },
    });
};

const createPostListWidgetCarousel = () => {
    const swiper = createCarousel(".post-carousel .attrax-list-widget__list--has-items", {
        modules: [ Navigation, Pagination ],
        slidesPerView: 1,
        navigation: true,
        spaceBetween: 20,
        breakpoints: {
            0: {
                slidesPerView: 1,
            },
            630: {
                slidesPerView: 2,
            },
            990: {
                slidesPerView: 3,
            },
        },
        on: {
            afterInit: (swiper) => {
                createNavigationButtonContainer(swiper);
                createViewAllButtonContainer(swiper);
                fadeIn();
            },
        },
    });
};



const createQuotesCarousel = () => {
    createCarousel(".banner-testimonial", {
        modules: [ Navigation, Pagination, Autoplay ],
        watchOverflow: true,
        navigation: true,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        slidesPerView: 1.1,
        loop: true,
        spaceBetween: 10,
        autoplay: {
            delay: 5000,
            disableOnInteraction: true,
        },
        breakpoints: {
            0: {
                slidesPerView: 1.1,
            },
            630: {
                slidesPerView: 2.1,
            },
            990: {
                slidesPerView: 3,
            },
        },
    });
};


export const CreateCarousels = () => {
    createListWidgetCarousel();
    createQuotesCarousel();
    createPostListWidgetCarousel();
};
